export default () => ({
	message: '',
	notified: 0,
	documentBadge: false,
	persons: [],
	person: null,
	personsByUser: [],
	loading: false,
});
